import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { MenuList, MenuItem, Paper, Button } from "@mui/material";
import ContextMenu from "../ContextMenu/ContextMenu";
import { useDispatch, useSelector } from "react-redux";
import NewRecord from "./ContextActions/NewRecord";
import NewField from "./ContextActions/NewField";
import Delete from "./ContextActions/Delete";
import CopyAndPaste from "./ContextActions/CopyAndPaste";
import NewComment from "./ContextActions/NewComment";
import {DATA_TYPE } from "../../constants/datatypes";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import QuickAddModal from "./ContextActions/QuickAddModal";

const MODALS = {
  MNU_QUICK_FIELD_ADD: 'MNU_QUICK_FIELD_ADD',
  MNU_NEW_RECORD:"MNU_NEW_RECORD",
  MNU_NEW_OBJECT:"MNU_NEW_OBJECT",
  MNU_NEW_FIELD:"MNU_NEW_FIELD",
  DELETE: 'DELETE',
  MNU_COPIED:'MNU_COPIED',
  MNU_NEW_COMMENT: 'MNU_NEW_COMMENT'
};

const randomNumber = Math.random();

function JsonMenu (props) {
  const { t } = useTranslation();
  const [showContent, setContext] = useState(false);
  const [modalToOpen, setModalToOpen] = useState(null);
  // const [isCopied,setIsCopied] = useState({copy:false,paste:false});
  const [isDisable,setIsDisable] = useState(false);
  const dispatch = useDispatch();
  const parentScreen = useContext(ParentScreenCtx);
  const  type  = useSelector(
    (state) => state.treeData[parentScreen].leftTree.tree.body.selectedNode?.type
  );
  const { tree, currentTab } = useSelector((state) => state.treeData[parentScreen].rightTree);
  const templateHeader = tree.templateHeader;
  const selectedKeysArray = tree[currentTab].selectedKeysArray;
  const handleClick = (contextItem) => setModalToOpen(contextItem); 
  const {isCopied,setIsCopied} = props;
  const renderCount = useRef(0);

  const  showMenuOrNot = useMemo(() => {
    //Checking if template is Empty or Not.
    const isTemplateEmpty =
      currentTab === "body"
        ? tree[currentTab]?.translatedData[0]?.children?.length !== 0 &&
          tree[currentTab].selectedNode.ICON_DISPLAY !== "TEMPLATE_BODY_DOTS"
        : tree[currentTab]?.translatedData?.length !== 0;

    //Checking if node is Selected or not.
    const nodeSelected = Object.keys(tree[currentTab].selectedNode).length > 0;
    return isTemplateEmpty && nodeSelected;

  },[tree[currentTab]?.translatedData, tree[currentTab].selectedNode, tree])

  const checkDisable = ()=>{
    return selectedKeysArray.includes("ib-0") && currentTab === "body"
  }

  useEffect(()=>{
    setIsDisable(checkDisable());
  },[selectedKeysArray])

  

  return (
    <>
      {type === "inboundTemplate" &&
      showMenuOrNot &&
      !Array.isArray(templateHeader) && templateHeader?.FILETYPE === "JSON" ? (
        <ContextMenu targetId="rightTree">
          <Paper elevation={3} sx={{ width: "19rem" }}>
            <MenuList>
              <MenuItem name={t("MNU_NEW_OBJECT")} onClick={() => handleClick(MODALS.MNU_NEW_RECORD)}>
                <span className={"NEW_OBJECT"}></span>
                <span className={"margin-left-8"}>{t("MNU_NEW_OBJECT")}</span>
              </MenuItem>
              <MenuItem name={t("MNU_NEW_FLD")} onClick={() => handleClick(MODALS.MNU_NEW_FIELD)}>
                <span className={"FIELD"}></span>
                <span className={"margin-left-8"}>{t("MNU_NEW_FLD")}</span>
              </MenuItem>
              <MenuItem name={t("MNU_QUICK_FIELD_ADD")} onClick={() => handleClick(MODALS.MNU_QUICK_FIELD_ADD)}>
                <span className={"QUICK_ADD_FIELDS"}></span>
                <span className={"margin-left-8"}>{t("MNU_QUICK_FIELD_ADD")}</span>
              </MenuItem>
              <MenuItem name={t("MNU_USE_COMMENT")} onClick={() => handleClick(MODALS.MNU_NEW_COMMENT)}>
                <span className={"COMMENT"}></span>
                <span className={"margin-left-8"}>{t("MNU_USE_COMMENT")}</span>
              </MenuItem>
              <MenuItem disabled={isDisable} name={t("DELETE")} onClick={() => handleClick(MODALS.DELETE)}>
                <span className={"SYMBOL_DELETE"}></span>
                <span className={"margin-left-8"}>{t("DELETE")}</span>
              </MenuItem>
              <MenuItem disabled={isDisable} name={t("MNU_COPY")} onClick={()=>setIsCopied({paste:false,copy:true,dispatchFrom:'JSONMenu',treeType:""})}>
                <span className={"COPY"}></span>
                <span className={"margin-left-8"}>{t("MNU_COPY")}</span>
              </MenuItem>
              {isCopied?.copiedNodes?.length ? <MenuItem name={t("MNU_PASTE")} onClick={()=>setIsCopied({...isCopied,paste:true,dispatchFrom:'JSONMenu',treeType:parentScreen })}>
                <span className={"DOCUMENT"}></span>
                <span className={"margin-left-8"}>{t("MNU_PASTE")}</span>
              </MenuItem> : ''}
            </MenuList>
          </Paper>
        </ContextMenu>
      ) : (
        ""
      )}
      <NewRecord openModal={modalToOpen===MODALS.MNU_NEW_RECORD} toggle={handleClick} />
      <QuickAddModal openModal={modalToOpen === MODALS.MNU_QUICK_FIELD_ADD} toggle={() => handleClick(null)}></QuickAddModal>
      <NewField openModal={modalToOpen===MODALS.MNU_NEW_FIELD} toggle={handleClick}/>
      <Delete openModal={modalToOpen === MODALS.DELETE} toggle={() => handleClick(null)} type={type}></Delete>
      <NewComment openModal={modalToOpen === MODALS.MNU_NEW_COMMENT} toggle={() => handleClick(null)}></NewComment>
      <CopyAndPaste isCopied={isCopied} setIsCopied={setIsCopied} contextMenuType={"JSONMenu"} treeType={parentScreen}/>

    </>
  );
}

export default JsonMenu;
